import {
  Avatar,
  Button,
  Card,
  Divider,
  Form,
  Input,
  Radio,
  Select,
  Space,
  Image,
  Tooltip,
  Switch,
  Checkbox,
  InputNumber,
  DatePickerProps,
  DatePicker,
  Tabs,
  Modal,
  Upload,
  message,
  UploadFile,
  AutoComplete,
  Spin,
  Empty,
  Steps,
  Col,
  Row,
} from "antd";
import {
  CloseOutlined,
  CheckOutlined,
  CopyOutlined,
  GiftOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { debounce } from "lodash";
import cn from "classnames";
import {
  SetStateAction,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { getImgUrl, getParamValue, getQueryParams } from "../../utils";
import { jodiConfig } from "../../utils/editor-config";
import { responseNotification } from "../../utils/notify";
import { useLocation, useNavigate, useParams } from "react-router";
import BreadCrumb from "../Layouts/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import JoditEditor from "jodit-react";
import modalStyles from "../../styles/tailwind/List.module.css";
import Styles from "./Product.module.css";
import {
  AddBtn,
  ImageUploader,
  SubmitResetBtn,
  TreeSelectTwo,
} from "../common";
const catStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 8,
};
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";

// Ant Design DatePicker needs these Day.js plugins (otherwise: clone.weekday is not a function)
dayjs.extend(weekday);
dayjs.extend(localeData);
const { TabPane } = Tabs;
const TAB_KEYS = ["1", "2", "3", "4", "5", "6", "7", "8"];
const STEP_FIELDS: Record<string, any[]> = {
  "1": ["name", "brandId", "barCode", "categoryId", "productType"],
  "2": [], // image/video (usually not form-required)
  "3": [["variations"]], // variations list validator triggers
  "4": [], // editor based
  "5": ["productCondition"],
  "6": [], // add shipping required fields if you want
  "7": ["selfNumber", "rowNumber"],
  "8": [], // SEO optional; add if you want required
};
const { Search } = Input;
const { Option } = Select;
const AddRequestedProduct = (props: any) => {
  const editor = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const route = useParams();
  const shopId = (route as any)?.shopId;
  const url = location?.pathname;
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [error, setError] = useState("");
  const [bannerImgUrl, setBannerImgUrl] = useState<string>();
  const [basePriceCalculationType, setBasePriceCalculationType] =
    useState<any>();
  const [commissionAmount, setCommissionAmount] = useState<any>();
  const [commissionType, setCommissionType] = useState<any>();
  const [categoryData, setCategoryData] = useState<any>(undefined);
  const [catCommissionAmount, setCatCommissionAmount] = useState<any>();
  const [catCommissionType, setCatCommissionType] = useState<any>();
  const [activeKey, setActiveKey] = useState("1");

  const [completed, setCompleted] = useState<Record<string, boolean>>({
    "1": false,
    "2": false,
    "3": false,
    "4": false,
    "5": false,
    "6": false,
    "7": false,
    "8": false,
  });

  const onKeyChange = (key: string) => setActiveKey(key);

  const [key, setKey] = useState("");
  const segment = url.substring(url.lastIndexOf("/") + 1);
  const { type, token } = useSelector((state) => (state as any)?.authReducer);
  const [priceCalcType, setPriceCalcType] = useState("SHOP_BASED_COMMISSION");
  const [giftCardStartingDate, setGiftCardStartingDate] =
    useState<DatePickerProps["value"]>();
  const [giftCardEndingDate, setGiftCardEndingDate] =
    useState<DatePickerProps["value"]>();
  const [singleShopInfo, setSingleShopInfo] = useState<any>({
    loading: false,
    data: null,
  });
  const [productType, setProductType] = useState<any>("REGULAR");
  const [auctionType, setAuctionType] = useState("NORMAL");
  const [convertedText, setConvertedText] = useState("");
  const [convertedTextForFAQ, setConvertedTextForFAQ] = useState("");
  const [convertedTextForTermCondition, setConvertedTextForTermCondition] =
    useState("");
  const [form] = Form.useForm();
  const calcSalesPrice = (
    mrpInput: any,
    disType?: "disFlat" | "disPercentage" | null,
    flatInput?: any,
    percentInput?: any
  ) => {
    const mrp = Number(mrpInput) || 0;

    if (!disType) return mrp;

    if (disType === "disFlat") {
      const flat = Number(flatInput) || 0;
      return Math.max(0, mrp - flat);
    }

    if (disType === "disPercentage") {
      const p = Number(percentInput) || 0;
      return Math.max(0, mrp - (mrp * p) / 100);
    }

    return mrp;
  };

  useEffect(() => {
    const vars = form.getFieldValue("variations");
    if (!Array.isArray(vars) || vars.length === 0) {
      form.setFieldsValue({
        variations: [{ variationId: genUniqueVariationId([]) }],
      });
      return;
    }
    const used = new Set(
      vars
        .map((v: any) => v?.variationId)
        .filter(Boolean)
        .map(String)
    );

    let changed = false;

    const next = vars.map((v: any) => {
      if (v?.variationId) return v;
      const newId = genUniqueVariationId(Array.from(used));
      used.add(newId);
      changed = true;
      return { ...v, variationId: newId };
    });

    if (changed) form.setFieldsValue({ variations: next });
  }, [form]);

  const [loading, setLoading] = useState(false);
  const [showSearch, setShowSearch] = useState(true);
  const [visible, setVisible] = useState(false);
  const [isActive, setIsActive] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [countryId, setCountryId] = useState<any>();
  const [allowFreeShipping, setAllowFreeShipping] = useState<any>(false);
  const [giftCardType, setGiftCardType] = useState("ONLINE");
  const [activationType, setActivationType] = useState("AFTER_ORDER");
  const [allowPriorityDelivery, setAllowPriorityDelivery] =
    useState<any>(false);
  const [allowStandardDelivery, setAllowStandardDelivery] =
    useState<any>(false);
  const [categorieOptions, setCategorieOptions] = useState({
    loading: false,
    list: [],
  });
  const [templateCategoryId, setTemplateCategoryId] = useState<any>();
  const [productName, setProductName] = useState("");
  const [languages, setLanguages] = useState<any>([]);
  const [languageOptions, setLanguageOptions] = useState<any>([]);
  const [nameWithLanguages, setNameWithLanguages] = useState<any>([]);
  const [allowEconomyDelivery, setAllowEconomyDelivery] = useState<any>(false);
  const [mideaFileType, setMideaFileType] = useState<any>("");
  const [isBattery, setIsBattery] = useState<any>(false);
  const [isLiquid, setIsLiquid] = useState<any>(false);
  const [isFlammable, setIsFlammable] = useState<any>(false);
  const [isNone, setIsNone] = useState<any>(false);
  const [variationImageUrl, setVariationImageUrl] = useState<string[]>([]);
  const [generatedImgUrl, setGeneratedImgUrl] = useState<any[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<any>(undefined);
  const [discountImageUrl, setDiscountImageUrl] = useState<string[]>([]);
  const [shippingTypes, setShippingTypes] = useState<string[]>([]);
  const [skuValue, setSkuValue] = useState<any>();
  const [endingDate, setEndingDate] = useState<DatePickerProps["value"]>();
  const [productWeightUnit, setProductWeightUnit] = useState<any>("kg");
  const [dimensionUnit, setDimensionUnit] = useState<any>("cm");
  const [categoryId, setCategoryId] = useState<any>();
  const [productCondition, setProductCondition] = useState();
  const [selectedImageIds, setSelectedImageIds] = useState<string[]>([]);
  const textRef = useRef<any>(null);

  const [attributesOptions, setAttributesOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [countryOptions, setCountryOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [fileName, setFileName] = useState("");
  const [manufactureDate, setManufactureDate] =
    useState<DatePickerProps["value"]>();
  const [restockDateTime, setRestockDateTime] =
    useState<DatePickerProps["value"]>();
  const [expireDate, setExpireDate] = useState<DatePickerProps["value"]>();
  const [startingDate, setStartingDate] = useState<DatePickerProps["value"]>();
  const [discountType, setDiscountType] = useState<{
    [key: string]: {
      type: "disFlat" | "disPercentage" | null;
      value: undefined | number;
    };
  }>({});

  const variationsWatch = Form.useWatch("variations", form);

  const baseType = String(basePriceCalculationType || priceCalcType || "")
    .toUpperCase()
    .trim();

  const isTpManual = baseType === "TP_BASED_COMMISSION";

  const calcCommission = (salesPrice: number, amount: any, type: any) => {
    const a = Number(amount) || 0;
    const t = String(type || "").toUpperCase();

    // supports: PERCENT / PERCENTAGE / % etc
    if (t.includes("PERCENT")) return (salesPrice * a) / 100;

    return a; // FLAT
  };

  const calcAutoTp = (salesPrice: number) => {
    if (baseType === "SHOP_BASED_COMMISSION") {
      const c = calcCommission(salesPrice, commissionAmount, commissionType);
      return Math.max(0, salesPrice - c);
    }

    if (baseType === "CATEGORY_BASED_COMMISSION") {
      const c = calcCommission(
        salesPrice,
        catCommissionAmount,
        catCommissionType
      );
      return Math.max(0, salesPrice - c);
    }

    return salesPrice; // fallback
  };

  useEffect(() => {
    if (isTpManual) return;

    const vars = form.getFieldValue("variations");
    if (!Array.isArray(vars) || vars.length === 0) return;

    let changed = false;

    const next = vars.map((v: any, i: number) => {
      const mrp = Number(v?.mrp) || 0;
      const disType = discountType?.[i]?.type ?? null;

      const sales = calcSalesPrice(mrp, disType, v?.flat, v?.percentage);
      const tp = calcAutoTp(sales);

      if (Number(v?.tp) !== Number(tp)) {
        changed = true;
        return { ...v, tp };
      }
      return v;
    });

    if (changed) form.setFieldsValue({ variations: next });
  }, [
    isTpManual,
    baseType,
    commissionAmount,
    commissionType,
    catCommissionAmount,
    catCommissionType,
    discountType,
    variationsWatch,
    form,
  ]);
  const [qtyDiscountType, setQtyDiscountType] = useState<{
    [key: string]: {
      type: "freeProduct" | "qtyFlat" | "qtyPercentage" | null;
      value: undefined | number;
      minimumQuantity: number;
    };
  }>({});
  const [directoryOptions, setDirectoryOptions] = useState({
    loading: false,
    list: [],
  });
  const [startUpload, setStartUpload] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >();

  const [startUpload2, setStartUpload2] = useState<
    "Initiated" | "Uploading" | "Uploaded" | any
  >(undefined);
  const [categorySuggestion, setCategorySuggestion] = useState<any>({
    loading: false,
    data: null,
  });
  const [singleProductInfo, setSingleProductInfo] = useState<any>({
    loading: false,
    data: null,
  });

  const [brandsOptions, setBrandsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [shopsOptions, setShopsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [productOptions, setProductOptions] = useState({
    loading: false,
    list: [],
  });

  function productSKU(length: any) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    setSkuValue(result.toUpperCase());
    return result;
  }
  // 6 digit numeric code (100000 - 999999)
  const gen6DigitCode = () =>
    String(Math.floor(100000 + Math.random() * 900000));

  const genUniqueVariationId = (existingIds: any[] = []) => {
    const used = new Set(existingIds.filter(Boolean).map(String));
    let id = gen6DigitCode();
    while (used.has(id)) id = gen6DigitCode();
    return id;
  };

  useEffect(() => {
    if (skuValue) {
      form.resetFields(["sku"]);
    }
  }, [skuValue]);

  const multi = (getQueryParams() as any)?.for === "multiple-shop";
  const getAttributesOptions = useCallback(async (val?: string) => {
    setAttributesOptions({ loading: true, list: [] });

    const res = await axios.get(
      `${process.env.REACT_APP_CATALOG_READER_API}/admin/product-attribute?type=${type}&page=0&limit=20` +
        (val ? `&name=${val}` : ``),

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setAttributesOptions({
      loading: false,
      list: res?.data?.productAttributes?.map((attribute: any) => {
        return {
          value: attribute?.id,
          label: attribute?.name,
          name: attribute?.name,
        };
      }),
    });
  }, []);

  const getCountryOptions = useCallback(async (countryName?: string) => {
    setCountryOptions({ loading: true, list: [] });
    const res = await axios.get(
      `${process.env.REACT_APP_RIDER_API}/admin/country-state/countries?page=0&limit=20` +
        (countryName ? `&key=${countryName}` : ``),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setCountryOptions({
      loading: false,
      list: res?.data?.countries?.map((country: any) => {
        return {
          value: country?.id,
          label: country?.name,
        };
      }),
    });
  }, []);

  const fetchProductDetails = useCallback((productSlug: any) => {
    if (productSlug) {
      if (segment === "edit") {
        try {
          setSingleProductInfo({ loading: true, data: null });
          axios
            .get(
              `${process.env.REACT_APP_CATALOG_READER_API}/merchant/product/details?slug=${productSlug}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((data) => {
              if (data.status === 200) {
                setSingleProductInfo({
                  loading: false,
                  data: data?.data?.product,
                });
                setConvertedText(data?.data?.product?.description || "");
                setConvertedTextForFAQ(data?.data?.product?.faq || "");
                setCategoryId(singleProductInfo?.data?.category?.id);
                setConvertedTextForTermCondition(
                  data?.data?.product?.termCondition || ""
                );
                setVariationImageUrl(
                  data?.data?.product?.variations?.map(
                    (item: any) => item?.imageUrl
                  )
                );

                setDiscountImageUrl(
                  data?.data?.product?.variations?.map(
                    (item: any) =>
                      item?.quantitativeProductDiscount?.freeProduct
                        ?.productImage
                  )
                );
                setIsActive(data?.data?.product?.isActive);
                setBannerImgUrl(data?.data?.product?.productImage);
                setGeneratedImgUrl(data?.data?.product?.images);

                const diss = {} as any;
                data?.data?.product?.variations?.map((va: any, i: string) => {
                  diss[i] = {
                    type: va?.productDiscount?.flat
                      ? "disFlat"
                      : va?.productDiscount?.percentage
                      ? "disPercentage"
                      : null,
                    value:
                      va?.productDiscount?.flat ||
                      va?.productDiscount?.percentage ||
                      0,
                  };
                });
                const qtyDis = {} as any;
                data?.data?.product?.variations?.map((va: any, i: string) => {
                  qtyDis[i] = {
                    type: va?.quantitativeProductDiscount?.freeProduct
                      ? "freeProduct"
                      : va?.quantitativeProductDiscount?.productDiscount?.flat
                      ? "qtyFlat"
                      : va?.quantitativeProductDiscount?.productDiscount
                          ?.percentage
                      ? "qtyPercentage"
                      : null,
                    value:
                      va?.quantitativeProductDiscount?.freeProduct ||
                      va?.quantitativeProductDiscount?.productDiscount?.flat ||
                      va?.quantitativeProductDiscount?.productDiscount
                        ?.percentage ||
                      0,
                    minimumQuantity:
                      va?.quantitativeProductDiscount?.minimumQuantity,
                  };
                });

                setDiscountType(diss);
                setQtyDiscountType(qtyDis);
              } else {
                setSingleProductInfo({ loading: false, data: null });
                responseNotification(
                  data.statusText || "something went wrong",
                  "error"
                );
              }
            })
            .catch((err) => {
              setSingleProductInfo({ loading: false, data: null });
            });
        } catch (error) {
          setSingleProductInfo({ loading: false, data: null });
        }
      } else {
        try {
          setSingleProductInfo({ loading: true, data: null });
          axios
            .get(
              `${process.env.REACT_APP_CATALOG_READER_API}/global-product/details?slug=${productSlug}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((data) => {
              if (data.status === 200) {
                setSingleProductInfo({
                  loading: false,
                  data: data?.data?.product,
                });
                setConvertedText(data?.data?.product?.description || "");
                setConvertedTextForFAQ(data?.data?.product?.faq || "");
                setCategoryId(singleProductInfo?.data?.category?.id);
                setConvertedTextForTermCondition(
                  data?.data?.product?.termCondition || ""
                );
                setVariationImageUrl(
                  data?.data?.product?.variations?.map(
                    (item: any) => item?.imageUrl
                  )
                );

                setDiscountImageUrl(
                  data?.data?.product?.variations?.map(
                    (item: any) =>
                      item?.quantitativeProductDiscount?.freeProduct
                        ?.productImage
                  )
                );
                setIsActive(data?.data?.product?.isActive);
                setGeneratedImgUrl(data?.data?.product?.images);

                const diss = {} as any;
                data?.data?.product?.variations?.map((va: any, i: string) => {
                  diss[i] = {
                    type: va?.productDiscount?.flat
                      ? "disFlat"
                      : va?.productDiscount?.percentage
                      ? "disPercentage"
                      : null,
                    value:
                      va?.productDiscount?.flat ||
                      va?.productDiscount?.percentage ||
                      0,
                  };
                });
                const qtyDis = {} as any;
                data?.data?.product?.variations?.map((va: any, i: string) => {
                  qtyDis[i] = {
                    type: va?.quantitativeProductDiscount?.freeProduct
                      ? "freeProduct"
                      : va?.quantitativeProductDiscount?.productDiscount?.flat
                      ? "qtyFlat"
                      : va?.quantitativeProductDiscount?.productDiscount
                          ?.percentage
                      ? "qtyPercentage"
                      : null,
                    value:
                      va?.quantitativeProductDiscount?.freeProduct ||
                      va?.quantitativeProductDiscount?.productDiscount?.flat ||
                      va?.quantitativeProductDiscount?.productDiscount
                        ?.percentage ||
                      0,
                    minimumQuantity:
                      va?.quantitativeProductDiscount?.minimumQuantity,
                  };
                });

                setDiscountType(diss);
                setQtyDiscountType(qtyDis);
              } else {
                setSingleProductInfo({ loading: false, data: null });
                responseNotification(
                  data.statusText || "something went wrong",
                  "error"
                );
              }
            })
            .catch((err) => {
              setSingleProductInfo({ loading: false, data: null });
            });
        } catch (error) {
          setSingleProductInfo({ loading: false, data: null });
        }
      }
    }
  }, []);

  useEffect(() => {
    if (startUpload === "Uploaded" && startUpload2 === "Uploaded") {
      form?.submit();
    }
  }, [startUpload, startUpload2]);

  const onSubmit = async (data: any) => {
    setLoading(true);
    let readyData = data && {
      barCode: data.barCode,
      productType: productType,
      sku: data.sku || skuValue,
      productOrigin: data.productOrigin,
      productVideoUrl: data.productVideoUrl,
      type: type,
      shopId: shopId,
      categoryId: categoryId,
      brandId: data.brandId,
      manufacturerName: data.manufacturerName,
      manufacturerContactInfo: data.manufacturerContactInfo,
      manufactureDate: manufactureDate,
      description: convertedText || "<p></p>",
      faq: convertedTextForFAQ || "<p></p>",
      termsCondition: convertedTextForTermCondition || "<p></p>",
      metaTitle: data.metaTitle,
      keyword: data.keyword,
      metaDescription: data.metaDescription,
      canonicalTag: data.canonicalTag,
      imageTitle: data.imageTitle,
      imageAltrText: data.imageAltrText,
      imageCaption: data.imageCaption,
      imageDescription: data.imageDescription,
      priceCalculationType: basePriceCalculationType,
      isActive: isActive,
      commissionType: commissionType || catCommissionType,
      commissionAmount:
        Math.round(data.commissionAmount) ||
        Math.round(data.catCommissionAmount),
      productImage: bannerImgUrl || "",
      images: generatedImgUrl,
      shippingInfo: {
        allowEconomyDelivery: allowEconomyDelivery,
        allowFreeShipping: allowFreeShipping,
        allowPriorityDelivery: allowPriorityDelivery,
        allowStandardDelivery: allowStandardDelivery,
        dimension: {
          height: data.dimensionHeight,
          length: data.dimensionLength,
          unit: dimensionUnit,
          width: data.dimensionWidth,
        },
        unit: productWeightUnit,
        weight: data.weight,
      },
      dangerousGoodsInfo: {
        isBattery: isBattery,
        isFlammable: isFlammable,
        isLiquid: isLiquid,
        safetyWarning: data.safetyWarning,
      },
      gondolaDetails: {
        rowNumber: data.rowNumber,
        selfNumber: data.selfNumber,
      },
      auction: {
        auctionType: auctionType,
        isCODAllowed: data.isCODAllowed,
        startingPrice: data.startingPrice,
        minimumIncrementAmount: data.minimumIncrementAmount,
        reservePrice: data.reservePrice,
        isBuyNowEnable: data.isBuyNowEnable,
        isSealed: data.isSealed,
        startDate: startingDate,
        endDate: endingDate,
        hasEnded: data.hasEnded,
      },
      productCondition: productCondition,
      iswrapAvailable: data.iswrapAvailable,
      handlingTimeFrom: data.handlingTimeFrom,
      handlingTimeTo: data.handlingTimeTo,
      expireDate: expireDate,
      restockDateTime: restockDateTime,
      name: productName || data.name,
      nameWithLanguages: nameWithLanguages?.map(
        (nameWithLang: any, langIndex: string) => ({
          languageCode: nameWithLang.languageCode,
          name: nameWithLang.name,
        })
      ),
      accessories: accessories?.map(
        (accessoriesProduct: any, accessPIndex: string) => ({
          id: accessoriesProduct.acessoriesName,
        })
      ),
      variations: data?.variations?.map((variant: any, i: string) => ({
        imageUrl: variant.imageUrl,
        barCode: variant.barCode,
        variationId: variant.variationId,
        variationName: variant.variationName,
        regularVariationId: data?.variations?.[i + 1]?.variationId,
        subsidyAmount: Math.round(variant?.subsidyAmount || 0),
        subsidyType: variant?.subsidyType,
        maximumOrderLimit: variant.maximumOrderLimit
          ? parseInt(variant.maximumOrderLimit)
          : undefined,
        stock: Math.round(variant.stock) || 0,
        platformProfit: Math.round(variant.platformProfit) || 0,
        sellerPurchasePrice: Math.ceil(variant.sellerPurchasePrice) * 1 || 0,
        upcNumber: variant.upcNumber,
        jsinnumber: variant.jsinnumber,
        pointAmount: variant.pointAmount,
        sellerProfit: variant.sellerProfit,
        price: {
          mrp: Math.ceil(variant.mrp) * 1 || 10,
          tp:
            priceCalcType == "TP_BASED_COMMISSION"
              ? Math.round(variant.tp) * 1
              : 0,
        },
        productDiscount: {
          flat: Math.round(variant.flat) || 0,
          percentage: Math.round(variant.percentage) || 0,
        },
        specialDiscountPrice: {
          discountPrice: variant?.discountPrice,
          endAt: variant?.endAt,
          startAt: variant?.startAt,
        },
        attributes: variant.attributes?.map(
          (attribute: any, attributeIndex: string) => ({
            attributeId: attribute.attributeId,
            imageUrl: attribute.imageUrl,
            name: attribute.attributeName,
          })
        ),
        quantitativeProductDiscount: {
          freeProductId:
            variant?.quantitativeProductDiscount?.freeProductId || null,
          minimumQuantity:
            variant?.quantitativeProductDiscount?.minimumQuantity || 0,
          productDiscount: {
            flat:
              parseFloat(
                variant?.quantitativeProductDiscount?.productDiscount.flat
              ) || 0,
            percentage:
              parseFloat(
                variant?.quantitativeProductDiscount?.productDiscount.percentage
              ) || 0,
          },
        },
      })),
    };

    if (singleProductInfo?.data && segment === "edit") {
      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/merchant/product${
          multi ? `/multiple-shop` : ``
        }`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...readyData,
            id: singleProductInfo?.data?.id,
            // isActive: isActive,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Product Updated Successfully", "success");
            form.resetFields();
            fetchProductDetails((route as any)?.slug);
            // if (history?.length === 1) {
            //   navigate(`/products`);
            // } else {
            //   navigate(-1);
            // }
            navigate(-1);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else {
      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/merchant/product`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...readyData,
            deleted: false,
            isActive: isActive,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);
          if (res.statusCode === 200) {
            responseNotification("Product Create Successfully", "success");
            form.resetFields();
            navigate(-1);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const getBrandsOptions = useCallback(async (val?: string) => {
    setBrandsOptions({ loading: true, list: [] });

    const res = await axios.get(
      `${process.env.REACT_APP_CATALOG_READER_API}/brand/search?type=${type}&page=0&limit=20` +
        (val ? `&key=${val}` : ``),

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setBrandsOptions({
      loading: false,
      list: res?.data?.brands?.map((brand: any) => {
        return {
          value: brand?.id,
          label: brand?.name,
        };
      }),
    });
  }, []);

  const getCategoriesOptions = useCallback(async (key?: string) => {
    setCategorieOptions({ loading: true, list: [] });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    const res = await axios.get(
      `${encodedUri}/gift-card-template-category/all?page=0&limit=20` +
        (key ? `&key=${key}` : ``),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setCategorieOptions({
      loading: false,
      list: res?.data?.categories?.map((categorie: any) => ({
        label: categorie.title,
        value: categorie.id,
      })),
    });
  }, []);
  const getProductOptions = useCallback(
    async (key: any) => {
      setProductOptions({ loading: true, list: [] });
      setAccessoriesProduct({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      return axios
        .get(
          `${encodedUri}/global-product?type=${type}&page=0&limit=20` +
            (key ? `&key=${key}` : ``),
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          setProductOptions({
            loading: false,
            list: res.data?.products?.map((product: any) => ({
              label: product?.name,
              value: product?.slug,
            })),
          });

          setAccessoriesProductOptions(res.data?.products);
        })
        .catch((err) => {
          setProductOptions({ loading: false, list: [] });
          console.error("products: Error", err);
        });
    },
    [type]
  );

  useEffect(() => {
    if (singleProductInfo?.data) {
      setShopsOptions({
        loading: false,
        list: [
          {
            value: singleProductInfo?.data?.shop?.id,
            label: singleProductInfo?.data?.shop?.name,
          },
        ],
      });

      setBrandsOptions({
        loading: false,
        list: [
          {
            value: singleProductInfo?.data?.brand?.id,
            label: singleProductInfo?.data?.brand?.name,
          },
          ...(brandsOptions.list?.filter(
            (item) => item.value !== singleProductInfo?.data?.brand?.id
          ) || []),
        ],
      });

      form.resetFields(Object.keys(singleProductInfo?.data));
      form.resetFields();
      setProductType(singleProductInfo?.data?.productType);
      setAuctionType(singleProductInfo?.data?.auction?.auctionType);
      setEndingDate(singleProductInfo?.data?.auction?.endDate);
      setExpireDate(singleProductInfo?.data?.expireDate);
      setRestockDateTime(singleProductInfo?.data?.restockDateTime);
      setManufactureDate(singleProductInfo?.data?.manufactureDate);
      setCategoryId(singleProductInfo?.data?.category?.id);
      setProductName(singleProductInfo?.data?.name);
      setLanguages(singleProductInfo?.data?.nameWithLanguages || []);
      setAccessories(singleProductInfo?.data?.accessories || []);
      setBannerImgUrl(singleProductInfo?.data?.productImage);
      setGeneratedImgUrl(singleProductInfo?.data?.images || []);
      setVariationImageUrl(
        singleProductInfo?.data?.variations?.map((item: any) => item?.imageUrl)
      );
    }
  }, [form, singleProductInfo?.data]);
  const validateStep = async (stepKey: string) => {
    // Step 3 (Variation & Price): required fields must be filled before Next
    if (stepKey === "3") {
      const vars = form.getFieldValue("variations") || [];
      if (!Array.isArray(vars) || vars.length < 1) {
        responseNotification("At least 1 variation required!", "warning");
        throw new Error("At least 1 variation required");
      }

      const toValidate: any[] = [];
      vars.forEach((_: any, i: number) => {
        toValidate.push(["variations", i, "variationName"]);
        toValidate.push(["variations", i, "mrp"]);
        toValidate.push(["variations", i, "stock"]);
        if (isTpManual) toValidate.push(["variations", i, "tp"]);
      });

      await form.validateFields(toValidate);
      return;
    }

    const fields = STEP_FIELDS[stepKey] || [];
    if (fields.length) {
      await form.validateFields(fields);
    }
  };

  const goNext = async () => {
    try {
      await validateStep(activeKey);
      setCompleted((prev) => ({ ...prev, [activeKey]: true }));
      const idx = TAB_KEYS.indexOf(activeKey);
      const nextKey = TAB_KEYS[idx + 1];
      if (nextKey) setActiveKey(nextKey);
    } catch (e) {
      return;
    }
  };

  const goPrev = () => {
    const idx = TAB_KEYS.indexOf(activeKey);
    const prevKey = TAB_KEYS[idx - 1];
    if (prevKey) setActiveKey(prevKey);
  };

  const goToStep = async (nextIndex: number) => {
    // user clicks Steps bar
    // allow going back always
    const nextKey = TAB_KEYS[nextIndex];
    const currentIndex = TAB_KEYS.indexOf(activeKey);

    if (nextIndex <= currentIndex) {
      setActiveKey(nextKey);
      return;
    }

    // going forward => must validate current step first
    try {
      await validateStep(activeKey);
      setCompleted((prev) => ({ ...prev, [activeKey]: true }));
      setActiveKey(nextKey);
    } catch (e) {
      responseNotification("Please fill required fields first", "warning");
    }
  };

  const resetData = () => {
    form?.resetFields();
    setVariationImageUrl([]);
    setGeneratedImgUrl(singleProductInfo?.data?.images || []);
    setBannerImgUrl(singleProductInfo?.data?.productImage);
    setBannerImgUrl(undefined);
    setStartUpload(undefined);
    setStartUpload2(undefined);
  };

  const ProductWightSelector = (
    <Select
      defaultValue="kg"
      style={{ width: 100 }}
      className="text-left"
      onChange={(val) => setProductWeightUnit(val)}
    >
      <Option value="kg">Kilogram</Option>
      <Option value="g">Gram</Option>
      <Option value="mg">Milligram</Option>
      <Option value="µg">Microgram</Option>
      <Option value="t">Tonne</Option>
    </Select>
  );

  const [accessoriesProduct, setAccessoriesProduct] = useState({
    loading: false,
    list: [],
  });
  const [accessoriesProductOptions, setAccessoriesProductOptions] =
    useState<any>([]);
  const [accessories, setAccessories] = useState<any>([]);
  const [nameWithAccessories, setNameWithAccessories] = useState<any>([]);
  const removeProductAccessories = (index) => {
    const updatedAccessories = [...accessories];
    updatedAccessories.splice(index, 1);
    setAccessories(updatedAccessories);

    const updatedNameWithAccessories = [...nameWithAccessories];
    updatedNameWithAccessories.splice(index, 1);
    setNameWithAccessories(updatedNameWithAccessories);
  };

  const addProductAccessories = () => {
    setAccessories([...accessories, { acessoriesName: "" }]);
  };

  const handleProductAccessoriesChange = (index, value) => {
    const updatedAccessories = [...accessories];
    updatedAccessories[index].acessoriesName = value;
    setAccessories(updatedAccessories);
  };

  const fetchLanguages = async () => {
    try {
      const response = await fetch(
        "https://driver-service.ejachai.com/api/v1/admin/country-state/all-languages"
      );
      const data = await response.json();
      if (data.statusCode === 200) {
        const options: any = Object.entries(data.languages).map(
          ([code, name]) => ({ code, name })
        );
        setLanguageOptions(options);
      } else {
        console.error("Failed to fetch languages:", data.message);
      }
    } catch (error) {
      console.error("Failed to fetch languages:", error);
    }
  };
  useEffect(() => {
    fetchLanguages();
  }, []);

  const addLanguage = () => {
    setLanguages([...languages, { language: "", translatedName: "" }]);
  };

  const removeLanguage = (index) => {
    const updatedLanguages = [...languages];
    updatedLanguages.splice(index, 1);
    setLanguages(updatedLanguages);

    const updatedNameWithLanguages = [...nameWithLanguages];
    updatedNameWithLanguages.splice(index, 1);
    setNameWithLanguages(updatedNameWithLanguages);
  };

  const handleLanguageChange = (index, value) => {
    const updatedLanguages = [...languages];
    updatedLanguages[index].language = value;
    setLanguages(updatedLanguages);
  };

  const handleTranslate = async (index) => {
    const { language } = languages[index];
    const response = await fetch(
      `https://catalog-reader.ejachai.com/api/v1/translator/translate?fromLanguageCode=en&toLanguageCode=${language}&text=${productName}`
    );
    const data = await response.json();

    const translatedText = data.translation.translatedText;

    const updatedLanguages = [...languages];
    updatedLanguages[index].translatedName = translatedText;
    setLanguages(updatedLanguages);

    const updatedNameWithLanguages = [...nameWithLanguages];
    updatedNameWithLanguages[index] = {
      languageCode: language,
      name: translatedText,
    };
    setNameWithLanguages(updatedNameWithLanguages);
  };
  const onChangeCat = (e) => {
    const value = e.target.value;
    setCategoryId(value);
    form.setFieldsValue({ categoryId: value });
  };

  const getCategorySuggestion = useCallback(
    async (key: any) => {
      setCategorySuggestion({ loading: true, data: null });
      const baseUrl = `${process.env.REACT_APP_CATALOG_READER_API}`;
      let url = `product/category-suggestion?type=${type}&key=${encodeURIComponent(
        productName
      )}`;

      return axios
        .get(`${baseUrl}/${url}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          setCategorySuggestion({ loading: false, data: res.data });
        })
        .catch((err) => {
          setCategorySuggestion({ loading: false, data: [] });
          console.error("city: Error", err);
        });
    },
    [productName]
  );

  useEffect(() => {
    const run = async () => {
      if (!categoryId) return;

      try {
        const resp = await fetch(
          `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/detail?categoryId=${categoryId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const res = await resp.json();
        if (res.statusCode === 200) {
          setCategoryData(res?.category);
          setCatCommissionAmount(res?.category?.commissionAmount);
          setCatCommissionType(res?.category?.commissionType);
        } else
          responseNotification(res.message || "something wrong", "warning");
      } catch (err) {
        responseNotification(`Internal server error ${err}`, "error");
        console.error(err);
      }
    };

    run();
  }, [categoryId, token]);
  useEffect(() => {
    getAttributesOptions();
    getCategoriesOptions();
  }, [getAttributesOptions, getCategoriesOptions]);
  const fetchShopDetails = useCallback((shopId: any) => {
    if (shopId) {
      try {
        setSingleShopInfo({ loading: true, data: null });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/merchant-shop/my-shop-details?shopId=${shopId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setSingleShopInfo({
                loading: false,
                data: data?.data?.shop,
              });
              setBasePriceCalculationType(
                data?.data?.shop?.basePriceCalculationType
              );
              setCommissionAmount(data?.data?.shop?.commissionAmount);
              setCommissionType(data?.data?.shop?.commissionType);
              //setCheckDeliveryType(data?.data?.shop?.deliveryFulfillBy);
            } else {
              setSingleShopInfo({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setSingleShopInfo({ loading: false, data: null });
          });
      } catch (error) {
        setSingleShopInfo({ loading: false, data: null });
      }
    }
  }, []);

  useEffect(() => {
    fetchShopDetails(shopId);
  }, [fetchShopDetails]);

  const fetchRef = useRef(0);
  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (type) {
        if (value) {
          if (field === "brand") getBrandsOptions(value);
          if (field === "product") getProductOptions(value);
          if (field === "attribute") getAttributesOptions(value);
          if (field === "country") getCountryOptions(value);
        }
      } else {
        responseNotification("Select a type before search", "warning");
      }
    };

    return debounce(loadOptions, 800);
  }, [
    getBrandsOptions,
    getProductOptions,
    getAttributesOptions,
    getCountryOptions,
    type,
  ]);

  useEffect(() => {
    if (showSearch) {
      getProductOptions("");
    }
  }, [showSearch]);
  useEffect(() => {
    getBrandsOptions();
  }, [getBrandsOptions]);

  useEffect(() => {
    fetchProductDetails((route as any)?.slug);
  }, [fetchProductDetails, route]);

  useEffect(() => {
    getCategorySuggestion("");
    getCountryOptions();
  }, [getCategorySuggestion, getCountryOptions]);

  return (
    <>
      <div className="content-body rounded-2xl">
        <div className="">
          <Form
            name="control-hooks"
            form={form} // like ref
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            onFinish={onSubmit}
            initialValues={{
              ...singleProductInfo?.data,
              type: type || singleProductInfo?.data?.shop?.type,
              startingPrice: singleProductInfo?.data?.auction?.startingPrice,
              minimumIncrementAmount:
                singleProductInfo?.data?.auction?.minimumIncrementAmount,
              reservePrice: singleProductInfo?.data?.auction?.reservePrice,
              isBuyNowEnable: singleProductInfo?.data?.auction?.isBuyNowEnable,
              isSealed: singleProductInfo?.data?.auction?.isSealed,
              hasEnded: singleProductInfo?.data?.auction?.hasEnded,
              sku: skuValue || singleProductInfo?.data?.sku,
              prefix: "86",
              expireDate: dayjs(singleProductInfo?.data?.expireDate),
              restockDateTime: dayjs(singleProductInfo?.data?.restockDateTime),
              startDate: dayjs(singleProductInfo?.data?.auction?.startDate),
              endDate: dayjs(singleProductInfo?.data?.auction?.endDate),
              selfNumber: singleProductInfo?.data?.gondolaDetails?.selfNumber,
              rowNumber: singleProductInfo?.data?.gondolaDetails?.rowNumber,
            }}
            layout="vertical"
            autoComplete="off"
          >
            {/* ✅ Step progress header (custom design like screenshot) */}
            <div className="mb-4 px-2">
              {(() => {
                const steps = [
                  { key: "1", label: "Vital Info" },
                  { key: "2", label: "Image & Video" },
                  { key: "3", label: "Variation & Price" },
                  { key: "4", label: "Description" },
                  { key: "5", label: "Service" },
                  { key: "6", label: "Shipping" },
                  { key: "7", label: "Gondola" },
                  { key: "8", label: "SEO" },
                ];

                const activeIndex = Math.max(
                  0,
                  steps.findIndex((s) => s.key === activeKey)
                );

                return (
                  <div className="w-full overflow-x-auto">
                    <div className="min-w-[900px]">
                      <div className="relative mt-2">
                        {/* ✅ connector line: start at first dot center, end at last dot center */}
                        {(() => {
                          const edgePct = 100 / (steps.length * 2); // e.g. 8 steps => 6.25%
                          const totalPct = 100 - edgePct * 2;
                          const progressPct =
                            activeIndex <= 0
                              ? 0
                              : (activeIndex / (steps.length - 1)) * totalPct;

                          return (
                            <>
                              <div
                                className="absolute top-4 h-[3px] bg-gray-300"
                                style={{
                                  left: `${edgePct}%`,
                                  right: `${edgePct}%`,
                                }}
                              />
                              <div
                                className="absolute top-4 h-[3px] bg-emerald-500 transition-all"
                                style={{
                                  left: `${edgePct}%`,
                                  width: `${progressPct}%`,
                                }}
                              />
                            </>
                          );
                        })()}

                        <div className="grid grid-cols-8 gap-2">
                          {steps.map((s, idx) => {
                            const isDone = !!completed?.[s.key];
                            const isActive = s.key === activeKey;
                            const isFuture = idx > activeIndex;

                            const circleBase =
                              "flex items-center justify-center rounded-full w-8 h-8";

                            return (
                              <div key={s.key} className="text-center">
                                <div className="relative mx-auto w-8 h-8">
                                  <div
                                    className={
                                      isDone
                                        ? `${circleBase} bg-white border-4 border-emerald-500`
                                        : isActive
                                        ? `${circleBase} bg-white border-4 border-emerald-500`
                                        : `${circleBase} bg-gray-400`
                                    }
                                  >
                                    {isDone ? (
                                      <CheckOutlined
                                        style={{
                                          fontSize: 16,
                                          color: "#10b981",
                                        }}
                                      />
                                    ) : null}
                                  </div>
                                </div>
                                <div
                                  className={
                                    isDone || isActive
                                      ? "mt-2 text-xs font-medium text-gray-700"
                                      : "mt-2 text-xs font-medium text-gray-500"
                                  }
                                >
                                  {s.label}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })()}
            </div>

            <div className="grid grid-cols-2 xl:grid-cols-1 xl:gap-6">
              {/* add tabs */}
              <Tabs
                defaultActiveKey="1"
                activeKey={activeKey}
                onChange={(k) => {
                  // allow back
                  const nextIndex = TAB_KEYS.indexOf(k);
                  goToStep(nextIndex);
                }}
                tabBarStyle={{ display: "none" }}
              >
                <TabPane tab="Vital Info" key="1">
                  <div className={`col-span-full`}>
                    <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-4 mb-6 grid grid-cols-2 gap-x-4">
                      <h3 className="mb-4 text-xl font-bold col-span-2">
                        General Info
                      </h3>

                      <div className="col-span-2 mb-2">
                        <Form.Item name="shop_search">
                          <Select
                            allowClear
                            showSearch
                            placeholder="Filter by Product SKU,  Name,  Barcode, JSIN, UPC, GTIN, EAN, GCID, ISBN"
                            optionFilterProp="children"
                            onChange={(val) => fetchProductDetails(val)}
                            //onChange={(val) => setProductId(val)}
                            onSearch={(e) => handleSearch(e, "product")}
                            filterOption={() => {
                              return true;
                            }}
                            options={productOptions?.list}
                          ></Select>
                        </Form.Item>
                        {/* <Search placeholder="Product SKU,  Name,  Barcode, JSIN, UPC, GTIN, EAN, GCID, ISBN" /> */}
                      </div>
                      <div className="col-span-2 mb-1">
                        <Form.Item
                          hasFeedback
                          label="Product Name ( English)"
                          name="name"
                        >
                          <Input
                            type="text"
                            id="name"
                            value={productName}
                            onChange={(e) => setProductName(e.target.value)}
                            onBlur={() => productSKU(8)}
                            className="py-1.5 px-5 rounded-md border border-gray-200 w-full"
                            placeholder="Enter Your Product Name"
                          />
                        </Form.Item>
                      </div>

                      <div>
                        {languages.map((lang, index) => (
                          <div
                            key={index}
                            className="col-span-2 mb-2"
                            style={{ display: "flex", marginBottom: 8 }}
                          >
                            <div>
                              <select
                                value={lang.language}
                                onChange={(e) =>
                                  handleLanguageChange(index, e.target.value)
                                }
                                className="mb-2 mr-2 w-40 border border-gray-200 py-2 px-5 rounded-md"
                              >
                                <option value="">Select Language</option>
                                {languageOptions.map(({ code, name }) => (
                                  <option
                                    key={code}
                                    value={code}
                                    selected={
                                      code ===
                                      singleProductInfo?.data
                                        ?.nameWithLanguages?.[index]
                                        ?.languageCode
                                    }
                                  >
                                    {name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div>
                              <input
                                type="text"
                                value={
                                  singleProductInfo?.data?.nameWithLanguages?.[
                                    index
                                  ]?.name || lang.translatedName
                                }
                                className="py-1.5 px-5 rounded-md border border-gray-200 mr-2 w-80"
                              />
                            </div>
                            <div>
                              <Button
                                onClick={() => handleTranslate(index)}
                                className="p-2.5 rounded-md mt-0.5 mr-2"
                              >
                                Translate
                              </Button>
                            </div>
                            <div>
                              <Button onClick={() => removeLanguage(index)}>
                                Remove
                              </Button>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="col-span-2 mb-2">
                        <Button
                          className={Styles.addButton}
                          type="dashed"
                          onClick={addLanguage}
                          block
                          icon={<PlusOutlined />}
                        >
                          Add More Language
                        </Button>
                      </div>

                      <div>
                        <Form.Item
                          hasFeedback
                          label="Product Type"
                          rules={[
                            {
                              required: true,
                              message: "Product Type is Required!",
                            },
                          ]}
                          name="productType"
                          initialValue={productType}
                        >
                          <Select
                            options={[
                              { value: "REGULAR", label: "REGULAR" },
                              { value: "AUCTION", label: "AUCTION" },
                              {
                                value: "GIFTCARD_VOUCHER",
                                label: "GIFT CARD VOUCHER",
                              },
                              {
                                value: "GIFT_CARD",
                                label: "GIFT CARD",
                              },
                            ]}
                            placeholder="Enter Product Type"
                            onChange={(val) => setProductType(val)}
                          />
                        </Form.Item>
                      </div>
                      {productType === "GIFT_CARD" && (
                        <>
                          <Form.Item
                            label="GIFT CARD TYPE"
                            name="GIFTCARD_TYPE"
                            //initialValue={giftCardType}
                          >
                            <Select
                              allowClear
                              showSearch
                              placeholder="Select GIFT CARD TYPE"
                              defaultValue={giftCardType}
                              onChange={(val) => setGiftCardType(val)}
                              filterOption={() => {
                                return true;
                              }}
                            >
                              <Option value="ONLINE">ONLINE</Option>
                              <Option value="PHYSICAL">PHYSICAL</Option>
                              <Option value="E_GIFT_CARD">E-GIFT CARD</Option>
                            </Select>
                          </Form.Item>
                          <Form.Item
                            label="Activation Type"
                            name="activationType"
                            // initialValue={activationType}
                          >
                            <Select
                              placeholder="Select Activation Type"
                              defaultValue={activationType}
                              onChange={(val) => setActivationType(val)}
                            >
                              <Option value="AFTER_ORDER">AFTER ORDER</Option>
                              <Option value="DATE_RANGE">DATE RANGE</Option>
                            </Select>
                          </Form.Item>
                          {activationType === "AFTER_ORDER" && (
                            <>
                              <Form.Item
                                hasFeedback
                                label="Expired In Days"
                                rules={[
                                  {
                                    required: false,
                                    message: "Expired In Days is Required!",
                                  },
                                ]}
                                name="expiredInDays"
                              >
                                <Input
                                  id="expiredInDays"
                                  type="number"
                                  min={0}
                                  placeholder="Enter Expired In Days"
                                />
                              </Form.Item>
                            </>
                          )}
                          {activationType === "DATE_RANGE" && (
                            <>
                              <Form.Item
                                hasFeedback
                                label="Starting Date"
                                rules={[
                                  {
                                    required: true,
                                    message: "Starting Date is Required!",
                                  },
                                ]}
                                name="startDate"
                              >
                                <DatePicker
                                  showTime
                                  style={{ minWidth: "100%" }}
                                  showNow={false}
                                  placeholder="Starting Date"
                                  onChange={(val: DatePickerProps["value"]) =>
                                    setGiftCardStartingDate(val)
                                  }
                                />
                              </Form.Item>
                              <Form.Item
                                hasFeedback
                                label="Ending Date"
                                rules={[
                                  {
                                    required: true,
                                    message: "Ending Date is Required!",
                                  },
                                ]}
                                name="endDate"
                              >
                                <DatePicker
                                  showTime
                                  id="endDate"
                                  placeholder="Enter Ending Date"
                                  showNow={false}
                                  style={{ minWidth: "100%" }}
                                  onChange={(val: DatePickerProps["value"]) =>
                                    setGiftCardEndingDate(val)
                                  }
                                  disabled={!giftCardStartingDate}
                                  disabledDate={(currentDate) =>
                                    currentDate.isBefore(
                                      dayjs(giftCardStartingDate)
                                    )
                                  }
                                />
                              </Form.Item>
                            </>
                          )}
                          {giftCardType === "E_GIFT_CARD" && (
                            <>
                              <Form.Item
                                hasFeedback
                                label="E-Gift Card Template Category"
                                name="templateCategoryId"
                              >
                                <Select
                                  showSearch
                                  placeholder="Select Template"
                                  optionFilterProp="children"
                                  defaultValue={templateCategoryId}
                                  onSelect={(val: any) =>
                                    setTemplateCategoryId(val)
                                  }
                                  onSearch={(val) => getCategoriesOptions(val)}
                                  filterOption={() => {
                                    return true;
                                  }}
                                  options={categorieOptions.list}
                                ></Select>
                              </Form.Item>
                            </>
                          )}
                        </>
                      )}

                      {productType === "AUCTION" && (
                        <>
                          <div>
                            <Form.Item
                              hasFeedback
                              label="Auction Type"
                              rules={[
                                {
                                  required: true,
                                  message: "Auction Type is Required!",
                                },
                              ]}
                              name="auctionType"
                              initialValue={auctionType}
                            >
                              <Select
                                options={[
                                  { value: null, label: "NONE" },
                                  { value: "NORMAL", label: "NORMAL" },
                                  { value: "REVERSE", label: "REVERSE" },
                                ]}
                                placeholder="Enter Auction Type"
                                onChange={(val) => setAuctionType(val)}
                              />
                            </Form.Item>
                          </div>
                          <div>
                            <Form.Item
                              hasFeedback
                              label="Starting Price"
                              rules={[
                                {
                                  required: true,
                                  message: "Starting Price is Required!",
                                },
                              ]}
                              name="startingPrice"
                            >
                              <Input
                                id="startingPrice"
                                type="number"
                                min={0}
                                placeholder="Enter Starting Price"
                              />
                            </Form.Item>
                          </div>
                          <div>
                            <Form.Item
                              hasFeedback
                              label="Minimum Increment Amount"
                              rules={[
                                {
                                  required: true,
                                  message:
                                    "Minimum Increment Amount is Required!",
                                },
                              ]}
                              name="minimumIncrementAmount"
                            >
                              <Input
                                id="minimumIncrementAmount"
                                type="number"
                                min={0}
                                placeholder="Enter Minimum Increment Amount"
                              />
                            </Form.Item>
                          </div>
                          {auctionType === "REVERSE" && (
                            <>
                              <div>
                                <Form.Item
                                  hasFeedback
                                  label="Reserve Price"
                                  rules={[
                                    {
                                      required: false,
                                      message: "Reserve Price is Required!",
                                    },
                                  ]}
                                  name="reservePrice"
                                >
                                  <Input
                                    id="reservePrice"
                                    type="number"
                                    min={0}
                                    placeholder="Enter Reserve Price"
                                  />
                                </Form.Item>
                              </div>
                            </>
                          )}

                          <div className="">
                            <Form.Item
                              hasFeedback
                              label="IS Buy Now Enable?"
                              name="isBuyNowEnable"
                              className="mr-5"
                            >
                              <Switch
                                checkedChildren={`true`}
                                unCheckedChildren={`false`}
                                defaultChecked={
                                  (singleProductInfo as any)?.data?.auction
                                    ?.isBuyNowEnable
                                }
                              />
                            </Form.Item>
                          </div>
                          <div className="">
                            <Form.Item
                              hasFeedback
                              label="IS Sealed?"
                              name="isSealed"
                              className="mr-5"
                            >
                              <Switch
                                checkedChildren={`true`}
                                unCheckedChildren={`false`}
                                defaultChecked={
                                  (singleProductInfo as any)?.data?.auction
                                    ?.isSealed
                                }
                              />
                            </Form.Item>
                          </div>
                          <div>
                            <Form.Item
                              hasFeedback
                              label="Starting Date"
                              rules={[
                                {
                                  required: true,
                                  message: "Starting Date is Required!",
                                },
                              ]}
                              name="startDate"
                            >
                              <DatePicker
                                showTime
                                style={{ minWidth: "100%" }}
                                showNow={false}
                                placeholder="Starting Date"
                                onChange={(val: DatePickerProps["value"]) =>
                                  setStartingDate(val)
                                }
                              />
                            </Form.Item>
                          </div>

                          <div>
                            <Form.Item
                              hasFeedback
                              label="Ending Date"
                              rules={[
                                {
                                  required: true,
                                  message: "Ending Date is Required!",
                                },
                              ]}
                              name="endDate"
                            >
                              <DatePicker
                                showTime
                                id="endDate"
                                placeholder="Enter Ending Date"
                                showNow={false}
                                style={{ minWidth: "100%" }}
                                onChange={(val: DatePickerProps["value"]) =>
                                  setEndingDate(val)
                                }
                                disabled={!startingDate}
                                disabledDate={(currentDate) =>
                                  currentDate.isBefore(dayjs(startingDate))
                                }
                              />
                            </Form.Item>
                          </div>
                          <div className="">
                            <Form.Item
                              hasFeedback
                              label="Has Ended?"
                              name="hasEnded"
                              className="mr-5"
                            >
                              <Switch
                                checkedChildren={`true`}
                                unCheckedChildren={`false`}
                                defaultChecked={
                                  (singleProductInfo as any)?.data?.auction
                                    ?.hasEnded
                                }
                              />
                            </Form.Item>
                          </div>
                          <div className="">
                            <Form.Item
                              hasFeedback
                              label="Is COD Allowed?"
                              name="hasEnded"
                              className="mr-5"
                            >
                              <Switch
                                checkedChildren={`true`}
                                unCheckedChildren={`false`}
                                defaultChecked={
                                  (singleProductInfo as any)?.data?.auction
                                    ?.isCODAllowed
                                }
                              />
                            </Form.Item>
                          </div>
                        </>
                      )}
                      <div>
                        <Form.Item
                          hasFeedback
                          label="Product Barcode"
                          name="barCode"
                          rules={[
                            {
                              required: true,
                              message: "Product Barcode is Required!",
                            },
                          ]}
                        >
                          <Input
                            id="barCode"
                            type="text"
                            placeholder="Scan Barcode"
                          />
                        </Form.Item>
                      </div>

                      <div className="">
                        <Form.Item
                          hasFeedback
                          label="Product Origin"
                          rules={[
                            {
                              required: false,
                              message: "Product Origin Name is Required!",
                            },
                          ]}
                          name="country"
                          // initialValue="BD"
                        >
                          <Select
                            allowClear
                            showSearch
                            placeholder="Select Product Origin"
                            optionFilterProp="children"
                            defaultValue={countryId}
                            onChange={(val) => setCountryId(val)}
                            onSearch={(val) => {
                              handleSearch?.(val, "country");
                            }}
                            filterOption={() => {
                              return true;
                            }}
                            options={countryOptions?.list}
                          ></Select>
                        </Form.Item>
                      </div>
                      <div className="">
                        <Form.Item
                          hasFeedback
                          label="SKU"
                          name="sku"
                          rules={[
                            {
                              required: false,
                              message: "Product SKU is Required!",
                            },
                          ]}
                        >
                          <Input id="sku" type="text" placeholder="Enter SKU" />
                        </Form.Item>
                      </div>

                      <div className="col-span-2 mb-0">
                        <Form.Item
                          hasFeedback
                          label={`Category`}
                          name="categoryId"
                          rules={[
                            {
                              required: !categoryId,
                              message: "Category is required!",
                            },
                          ]}
                          initialValue={categoryId}
                        >
                          <TreeSelectTwo
                            setCategoryId={setCategoryId}
                            value={categoryId}
                          />
                        </Form.Item>
                      </div>
                      {categorySuggestion?.data?.suggestions?.length > 0 && (
                        <>
                          <div className="col-span-2 mb-8">
                            <h4>Suggest Category</h4>
                            <Radio.Group
                              onChange={onChangeCat}
                              style={catStyle}
                              value={categoryId}
                            >
                              {categorySuggestion?.data?.suggestions?.map(
                                (suggestCat: any, suggestCatIndex: any) => (
                                  <Radio
                                    key={suggestCatIndex}
                                    value={suggestCat?.id}
                                  >
                                    {suggestCat?.title}
                                  </Radio>
                                )
                              )}
                            </Radio.Group>
                          </div>
                        </>
                      )}

                      <div className="mb-4">
                        <Form.Item
                          hasFeedback
                          label={`Brand`}
                          name="brandId"
                          rules={[
                            {
                              required: true,
                              message: "Category is required!",
                            },
                          ]}
                        >
                          <Select
                            showSearch
                            placeholder="Select Brand"
                            optionFilterProp="children"
                            onSearch={(val) => {
                              handleSearch(val, "brand");
                            }}
                            filterOption={() => {
                              return true;
                            }}
                            options={brandsOptions?.list}
                          ></Select>
                        </Form.Item>
                      </div>

                      <div className="">
                        <Form.Item
                          hasFeedback
                          label="Manufacturer Name"
                          rules={[
                            {
                              required: false,
                              message: "Manufacturer is Required!",
                            },
                          ]}
                          name="manufacturerName"
                        >
                          <Input
                            id="manufacturerName"
                            type="text"
                            placeholder="Enter Manufacturer Name"
                          />
                        </Form.Item>
                      </div>
                      <div className="">
                        <Form.Item
                          hasFeedback
                          label="Manufacturer Contact 
                      Information"
                          rules={[
                            {
                              required: false,
                              message: "Contract Info is Required!",
                            },
                          ]}
                          name="manufacturerContactInfo"
                        >
                          <Input
                            id="manufacturerContactInfo"
                            type="text"
                            placeholder="Enter Manufacturer Contact 
                        Information"
                          />
                        </Form.Item>
                      </div>
                      <div className="">
                        <Form.Item
                          hasFeedback
                          label="Manufacture Date"
                          rules={[
                            {
                              required: false,
                              message: "Manufacture Date is Required!",
                            },
                          ]}
                          name="manufactureDate"
                        >
                          <DatePicker
                            style={{ minWidth: "100%" }}
                            placeholder="Manufacture Date"
                            onChange={(val: DatePickerProps["value"]) =>
                              setManufactureDate(val)
                            }
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  {/* <Button
                    size="large"
                    className="bg-green-600 hover:bg-green-500 hover:text-white border-none text-white font-semibold rounded-lg mr-1"
                    disabled={loading}
                    loading={loading}
                    onClick={() => onKeyChange("2")}
                  >
                    Save & Next "Tab 2"
                  </Button> */}
                </TabPane>
                <TabPane tab="Image & Video" key="2">
                  <div
                    className={`grid grid-cols-2 md:grid-cols-2 xl:grid-cols-1 col-span-3 md:col-span-3 lg:col-span-1 gap-6 grid-flow-row auto-rows-max mb-6`}
                  >
                    <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl px-4 pb-2">
                      <Row gutter={20} className="mb-6">
                        <Col span={6}>
                          <Divider orientation="left">
                            Thumbnail
                            <Tooltip
                              placement="bottom"
                              title={
                                "Thumbnail image should 250px/1600px (Ratio 6.4)"
                              }
                            >
                              <QuestionCircleOutlined className="px-2 -mt-2" />
                            </Tooltip>
                          </Divider>
                          <ImageUploader
                            imgUrl={bannerImgUrl || ""}
                            startUpload={startUpload}
                            setStartUpload={(val: any) => setStartUpload(val)}
                            setGeneratedImgUrl={(url: any) =>
                              setBannerImgUrl(Array.isArray(url) ? url[0] : url)
                            }
                          />
                        </Col>
                        <Col span={16}>
                          <Divider orientation="left">
                            Image Gallery
                            <Tooltip
                              placement="bottom"
                              title={
                                "Product image gallery should 250px/1600px (Ratio 6.4)"
                              }
                            >
                              <QuestionCircleOutlined className="px-2 -mt-2" />
                            </Tooltip>
                          </Divider>
                          <ImageUploader
                            // crop={6.4}
                            multiple
                            imgUrl={generatedImgUrl || ""}
                            startUpload={startUpload2}
                            setStartUpload={(val: any) => setStartUpload2(val)}
                            setGeneratedImgUrl={(url: any) =>
                              setGeneratedImgUrl(url)
                            }
                          />
                        </Col>
                      </Row>
                      <Row gutter={20} className="mb-6">
                        <Col span={12}>
                          <div className="mt-4">
                            <Form.Item
                              hasFeedback
                              label="Product Video URL"
                              rules={[
                                {
                                  required: false,
                                  message: "Product Video URL is Required!",
                                },
                              ]}
                              name="productVideoUrl"
                            >
                              <Input
                                id="productVideoUrl"
                                type="text"
                                placeholder="Enter Product Video URL"
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  {/* <button onClick={() => onKeyChange("1")}>
                    Go to "Tab 1"
                  </button> */}
                </TabPane>
                <TabPane tab="Variation & Price" key="3">
                  <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-4 mb-6 col-span-2">
                    <h3 className="mb-4 text-xl font-bold">Variations</h3>

                    <Form.List
                      name="variations"
                      rules={[
                        {
                          validator: async (_, names) => {
                            if (!names || names.length < 1) {
                              return Promise.reject(
                                new Error("At least 1 variation required!")
                              );
                            }
                          },
                        },
                      ]}
                      initialValue={[{}]}
                    >
                      {(fields, { add, remove }, { errors }) => (
                        <>
                          {fields.map(
                            ({ key, name, fieldKey, ...restField }: any) => {
                              const v = variationsWatch?.[name] || {};
                              const mrpVal =
                                v?.mrp ??
                                singleProductInfo?.data?.variations?.[name]
                                  ?.price?.mrp ??
                                0;

                              const salesPriceVal = calcSalesPrice(
                                mrpVal,
                                discountType?.[name]?.type ?? null,
                                v?.flat,
                                v?.percentage
                              );

                              return (
                                <Card className="mb-2" size="small" key={key}>
                                  <Space wrap align="center">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "variationId"]}
                                      fieldKey={[fieldKey, "variationId"]}
                                      hasFeedback
                                      label="ID"
                                      style={{ width: 80 }}
                                      initialValue={
                                        singleProductInfo?.data?.variations?.[
                                          name
                                        ]?.variationId
                                      }
                                    >
                                      <Input
                                        id="variationId"
                                        placeholder="Auto Generated"
                                        disabled
                                      />
                                    </Form.Item>
                                    <Form.Item
                                      {...restField}
                                      name={[name, "variationName"]}
                                      fieldKey={[fieldKey, "variationName"]}
                                      hasFeedback
                                      label="Name"
                                      rules={[
                                        {
                                          required: true,
                                          message: "Required!",
                                        },
                                      ]}
                                      style={{ width: 90 }}
                                      initialValue={
                                        singleProductInfo?.data?.variations?.[
                                          name
                                        ]?.variationName
                                      }
                                    >
                                      <Input placeholder="1pc/5kg/1pkt" />
                                    </Form.Item>

                                    <Form.Item
                                      {...restField}
                                      name={[name, "barCode"]}
                                      fieldKey={[fieldKey, "barCode"]}
                                      hasFeedback
                                      label="Barcode"
                                      rules={[
                                        {
                                          required: false,
                                          message: "Required!",
                                        },
                                      ]}
                                      style={{ width: 100 }}
                                      initialValue={
                                        singleProductInfo?.data?.variations?.[
                                          name
                                        ]?.barCode
                                      }
                                    >
                                      <Input placeholder="Enter Barcode" />
                                    </Form.Item>
                                    <Form.Item
                                      {...restField}
                                      name={[name, "mrp"]}
                                      fieldKey={[fieldKey, "mrp"]}
                                      hasFeedback
                                      label="MRP"
                                      style={{ width: 90 }}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Required!",
                                        },
                                      ]}
                                      initialValue={
                                        singleProductInfo?.data?.variations?.[
                                          name
                                        ]?.price?.mrp
                                      }
                                    >
                                      <Input placeholder="Enter MRP" />
                                    </Form.Item>
                                    <Form.Item
                                      {...restField}
                                      name={[name, "tp"]}
                                      fieldKey={[fieldKey, "tp"]}
                                      hasFeedback
                                      label="TP"
                                      style={{ width: 110 }}
                                      rules={
                                        isTpManual
                                          ? [
                                              {
                                                required: true,
                                                message: "Required!",
                                              },
                                            ]
                                          : []
                                      }
                                    >
                                      <Input
                                        placeholder={
                                          isTpManual
                                            ? "Enter TP Price"
                                            : "Auto TP"
                                        }
                                        disabled={!isTpManual}
                                      />
                                    </Form.Item>

                                    <Form.Item
                                      label="Sales Price"
                                      hasFeedback
                                      style={{ width: 110 }}
                                    >
                                      <Input
                                        disabled
                                        value={(() => {
                                          const v =
                                            variationsWatch?.[name] || {};
                                          const mrpVal =
                                            v?.mrp ??
                                            singleProductInfo?.data
                                              ?.variations?.[name]?.price
                                              ?.mrp ??
                                            0;

                                          return calcSalesPrice(
                                            mrpVal,
                                            discountType?.[name]?.type ?? null,
                                            v?.flat,
                                            v?.percentage
                                          );
                                        })()}
                                        placeholder="Auto"
                                      />
                                    </Form.Item>
                                    <Form.Item
                                      {...restField}
                                      name={[name, "maximumOrderLimit"]}
                                      fieldKey={[fieldKey, "maximumOrderLimit"]}
                                      hasFeedback
                                      label="Max Limit"
                                      initialValue={
                                        singleProductInfo?.data?.variations?.[
                                          name
                                        ]?.maximumOrderLimit
                                      }
                                      style={{ width: 80 }}
                                    >
                                      <Input placeholder="Maximum Order Limit" />
                                    </Form.Item>

                                    <Form.Item
                                      {...restField}
                                      name={[name, "stock"]}
                                      fieldKey={[fieldKey, "stock"]}
                                      hasFeedback
                                      label="Stock"
                                      initialValue={
                                        singleProductInfo?.data?.variations?.[
                                          name
                                        ]?.stock
                                      }
                                      rules={[
                                        {
                                          required: true,
                                          message: "Required!",
                                        },
                                      ]}
                                      style={{ width: 70 }}
                                    >
                                      <Input placeholder="Stock" />
                                    </Form.Item>
                                  </Space>
                                  <Space wrap align="center" className="mb-3">
                                    <div
                                      className="bg-green-500 text-white font-bold rounded-md px-3 flex items-center justify-center"
                                      style={{ height: 45, minWidth: 140 }}
                                    >
                                      Special Discount
                                    </div>

                                    <Form.Item
                                      {...restField}
                                      name={[name, "specialSellPrice"]}
                                      fieldKey={[fieldKey, "specialSellPrice"]}
                                      hasFeedback
                                      label="Special Sale Price"
                                      style={{ width: 140 }}
                                      initialValue={
                                        singleProductInfo?.data?.variations?.[
                                          name
                                        ]?.specialDiscountPrice?.discountPrice
                                      }
                                    >
                                      <Input
                                        id="specialSellPrice"
                                        placeholder="Special Sale Price"
                                        disabled={singleProductInfo?.data}
                                      />
                                    </Form.Item>
                                    <Form.Item
                                      {...restField}
                                      name={[name, "startAt"]}
                                      fieldKey={[fieldKey, "startAt"]}
                                      hasFeedback
                                      label="Start Date"
                                      style={{ width: 120 }}
                                      initialValue={
                                        singleProductInfo?.data?.variations?.[
                                          name
                                        ]?.specialDiscountPrice?.startAt
                                      }
                                    >
                                      <Input
                                        id="startAt"
                                        type="date"
                                        disabled={singleProductInfo?.data}
                                      />
                                    </Form.Item>
                                    <Form.Item
                                      {...restField}
                                      name={[name, "endAt"]}
                                      fieldKey={[fieldKey, "endAt"]}
                                      hasFeedback
                                      label="End Date"
                                      style={{ width: 120 }}
                                      initialValue={
                                        singleProductInfo?.data?.variations?.[
                                          name
                                        ]?.specialDiscountPrice?.endAt
                                      }
                                    >
                                      <Input
                                        id="endAt"
                                        type="date"
                                        placeholder="Enter Date"
                                        disabled={singleProductInfo?.data}
                                      />
                                    </Form.Item>
                                  </Space>
                                  <Space
                                    wrap
                                    align="center"
                                    style={{ display: "flex" }}
                                  >
                                    <div
                                      className="bg-green-500 text-white font-bold rounded-md px-3 flex items-center justify-center"
                                      style={{ height: 45, minWidth: 140 }}
                                    >
                                      Product Attributes
                                    </div>
                                    <Form.List
                                      name={[name, "attributes"]}
                                      initialValue={[{}]}
                                    >
                                      {(subFields, { add, remove }) => (
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            rowGap: 24,
                                          }}
                                        >
                                          {subFields.map(
                                            ({
                                              key: subKey,
                                              name: subName,
                                              ...subRestField
                                            }) => (
                                              <div
                                                key={subKey}
                                                style={{
                                                  display: "flex",
                                                  gap: 16,
                                                  alignItems: "flex-start",
                                                  flexWrap: "wrap",
                                                  padding: 12,
                                                  border: "1px solid #e5e7eb", // Tailwind: border-gray-200
                                                  borderRadius: 8,
                                                }}
                                              >
                                                <Form.Item
                                                  {...subRestField}
                                                  name={[
                                                    subName,
                                                    "attributeId",
                                                  ]}
                                                  label="Attributes"
                                                  style={{ minWidth: 160 }}
                                                  rules={[
                                                    {
                                                      required: true,
                                                      message: "Required",
                                                    },
                                                  ]}
                                                >
                                                  <Select
                                                    placeholder="Select Attribute"
                                                    options={
                                                      attributesOptions?.list
                                                    }
                                                    onChange={(value) => {
                                                      const selected =
                                                        attributesOptions.list.find(
                                                          (item) =>
                                                            item.value === value
                                                        );

                                                      // Set attributeName based on selected option
                                                      const allVariations =
                                                        form.getFieldValue(
                                                          "variations"
                                                        );
                                                      if (
                                                        !allVariations[name]
                                                          ?.attributes
                                                      )
                                                        return;

                                                      allVariations[
                                                        name
                                                      ].attributes[subName] = {
                                                        ...allVariations[name]
                                                          .attributes[subName],
                                                        attributeName:
                                                          selected?.name || "",
                                                      };

                                                      form.setFieldsValue({
                                                        variations:
                                                          allVariations,
                                                      });
                                                    }}
                                                  />
                                                </Form.Item>

                                                <Form.Item
                                                  {...subRestField}
                                                  name={[
                                                    subName,
                                                    "attributeName",
                                                  ]}
                                                  hasFeedback
                                                  label="Name"
                                                  style={{ width: 160 }}
                                                >
                                                  <Input placeholder="Attribute Name" />
                                                </Form.Item>

                                                <Form.Item
                                                  {...subRestField}
                                                  name={[subName, "imageUrl"]}
                                                  hasFeedback
                                                  label="Image Url"
                                                  style={{ width: 160 }}
                                                >
                                                  <Input placeholder="Image URL" />
                                                </Form.Item>
                                                <div style={{ marginTop: 30 }}>
                                                  <CloseOutlined
                                                    onClick={() =>
                                                      remove(subName)
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            )
                                          )}
                                          <Button
                                            type="dashed"
                                            onClick={() => add()}
                                            block
                                          >
                                            + Add Attributes
                                          </Button>
                                        </div>
                                      )}
                                    </Form.List>
                                  </Space>

                                  <Space
                                    wrap
                                    align="center"
                                    style={{ display: "flex" }}
                                    className=" mt-4"
                                  >
                                    <h6 className="bg-green-500 rounded text-white px-2 font-bold">
                                      General Discount
                                    </h6>
                                    <Radio.Group
                                      value={discountType[name]?.type}
                                      onChange={(e: any) => {
                                        setDiscountType((prev: any) => ({
                                          ...prev,
                                          [name]: {
                                            type: e.target.value,
                                            value: undefined,
                                          },
                                        }));
                                      }}
                                      name="productDiscount"
                                    >
                                      <Radio value={undefined}>None</Radio>
                                      <Radio value={`disFlat`}>Flat</Radio>

                                      <Radio value={`disPercentage`}>
                                        Percentage
                                      </Radio>
                                    </Radio.Group>
                                    <div className="">
                                      {discountType[name]?.type ===
                                        "disFlat" && (
                                        <Form.Item
                                          {...restField}
                                          name={[name, "flat"]}
                                          fieldKey={[fieldKey, "flat"]}
                                          initialValue={
                                            discountType?.[name]?.value
                                          }
                                          hasFeedback
                                          style={{
                                            width: 100,
                                            marginBottom: 0,
                                          }}
                                        >
                                          <Input
                                            placeholder="Flat (Tk.)"
                                            size="small"
                                          />
                                        </Form.Item>
                                      )}

                                      {discountType?.[name]?.type ===
                                        "disPercentage" && (
                                        <Form.Item
                                          {...restField}
                                          name={[name, "percentage"]}
                                          fieldKey={[fieldKey, "percentage"]}
                                          hasFeedback
                                          initialValue={
                                            discountType?.[name]?.value
                                          }
                                          style={{
                                            width: 100,
                                            marginBottom: 0,
                                          }}
                                        >
                                          <Input
                                            placeholder="Percent (%)"
                                            size="small"
                                          />
                                        </Form.Item>
                                      )}
                                    </div>
                                  </Space>

                                  <Space wrap key={key} align="center">
                                    <h6 className="bg-green-500 rounded text-white px-2 font-bold">
                                      Quantitive Discount
                                    </h6>

                                    <Radio.Group
                                      value={qtyDiscountType?.[name]?.type}
                                      onChange={(val) => {
                                        setQtyDiscountType(() => {
                                          const temp = {} as any;
                                          temp[name] = {
                                            type: val.target.value,
                                            value: undefined,
                                            minimumQuantity: undefined,
                                          };
                                          return temp;
                                        });
                                      }}
                                      name="quantitiveProductDiscount"
                                    >
                                      <Radio value={undefined}>None</Radio>
                                      <Radio value={`qtyFlat`}>Flat</Radio>
                                      <Radio value={`qtyPercentage`}>
                                        Percentage
                                      </Radio>
                                      <Radio value="freeProduct">
                                        Free Product
                                      </Radio>
                                    </Radio.Group>

                                    <Space wrap key={key} align="center">
                                      {qtyDiscountType?.[name]?.type !==
                                        null && (
                                        <Form.Item
                                          {...restField}
                                          name={[name, "minimumQuantity"]}
                                          fieldKey={[
                                            fieldKey,
                                            "minimumQuantity",
                                          ]}
                                          hasFeedback
                                          initialValue={
                                            qtyDiscountType?.[name]
                                              ?.minimumQuantity
                                          }
                                          style={{
                                            width: 100,
                                            marginBottom: 0,
                                          }}
                                        >
                                          <Input
                                            placeholder="Min Quantity"
                                            size="small"
                                          />
                                        </Form.Item>
                                      )}

                                      {qtyDiscountType?.[name]?.type ===
                                        "freeProduct" &&
                                        (qtyDiscountType?.[name]?.value ||
                                        selectedProduct?.productImage ? (
                                          <div className="d-flex align-items-start">
                                            {discountImageUrl && (
                                              <Avatar
                                                src={
                                                  <Image
                                                    src={
                                                      selectedProduct?.productImage ||
                                                      discountImageUrl[name]
                                                    }
                                                  />
                                                }
                                                shape="square"
                                                size="large"
                                                className="border"
                                              />
                                            )}
                                            <Button
                                              danger
                                              type="text"
                                              onClick={() =>
                                                setSelectedProduct(undefined)
                                              }
                                              size="large"
                                            >
                                              <CloseOutlined />
                                            </Button>
                                          </div>
                                        ) : (
                                          <Button
                                            type="dashed"
                                            onClick={() => setVisible(true)}
                                            size="large"
                                          >
                                            <GiftOutlined /> Free Product
                                          </Button>
                                        ))}

                                      {qtyDiscountType?.[name]?.type ===
                                        "qtyFlat" && (
                                        <Form.Item
                                          {...restField}
                                          name={[name, "qtyFlat"]}
                                          fieldKey={[fieldKey, "flat"]}
                                          hasFeedback
                                          initialValue={
                                            qtyDiscountType?.[name]?.value
                                          }
                                          style={{
                                            width: 100,
                                            marginBottom: 0,
                                          }}
                                        >
                                          <Input
                                            placeholder="Flat (Tk.)"
                                            size="small"
                                          />
                                        </Form.Item>
                                      )}

                                      {qtyDiscountType?.[name]?.type ===
                                        "qtyPercentage" && (
                                        <Form.Item
                                          {...restField}
                                          name={[name, "qtyPercentage"]}
                                          fieldKey={[fieldKey, "percentage"]}
                                          hasFeedback
                                          // label="Percentage Discount"
                                          initialValue={
                                            qtyDiscountType?.[name]?.value
                                          }
                                          style={{
                                            width: 100,
                                            marginBottom: 0,
                                          }}
                                        >
                                          <Input
                                            placeholder="Percent (%)"
                                            size="small"
                                          />
                                        </Form.Item>
                                      )}
                                    </Space>
                                  </Space>

                                  <Button
                                    type="primary"
                                    danger
                                    style={{
                                      position: "absolute",
                                      right: 0,
                                      bottom: 0,
                                    }}
                                    onClick={() => {
                                      remove(name);
                                      setVariationImageUrl((prev) => {
                                        const newArr = prev.filter(
                                          (_, i) => i !== name
                                        );
                                        return newArr;
                                      });
                                    }}
                                  >
                                    <CloseOutlined />
                                  </Button>
                                </Card>
                              );
                            }
                          )}

                          <Form.Item
                            style={{
                              width: "100%",
                              flex: "1 1 100%",
                              marginBottom: 5,
                            }}
                          >
                            <Button
                              type="dashed"
                              onClick={() => {
                                const existingIds = (
                                  form.getFieldValue("variations") || []
                                )
                                  .map((v: any) => v?.variationId)
                                  .filter(Boolean);

                                add({
                                  variationId:
                                    genUniqueVariationId(existingIds),
                                });

                                setVariationImageUrl((prev) => {
                                  const newArr = Array.from(prev);
                                  newArr.push("");
                                  return newArr;
                                });
                              }}
                              block
                              icon={<PlusOutlined />}
                            >
                              Add Variation
                            </Button>
                          </Form.Item>

                          <Form.ErrorList errors={errors} />
                        </>
                      )}
                    </Form.List>
                  </div>
                </TabPane>
                <TabPane tab="Description" key="4">
                  <div className={`col-span-full`}>
                    <div className="col-span-2 mb-1">
                      <Divider className="float-right w-full">
                        Product Accessories
                      </Divider>
                    </div>
                    <div>
                      {accessories.map((productAccess, index) => (
                        <div
                          key={index}
                          className="col-span-2 mb-2"
                          style={{ display: "flex", marginBottom: 4 }}
                        >
                          <div>
                            <select
                              value={productAccess.acessoriesName}
                              onChange={(e) =>
                                handleProductAccessoriesChange(
                                  index,
                                  e.target.value
                                )
                              }
                              className="py-1.5 px-5 rounded-md border border-gray-200 mr-2 w-90"
                            >
                              <option value="">Select Product</option>
                              {accessoriesProductOptions.map(
                                (getProductName, pIndex) => (
                                  <option
                                    key={pIndex}
                                    value={getProductName?.id}
                                    selected={
                                      getProductName?.id ===
                                      singleProductInfo?.data?.accessories?.[
                                        index
                                      ]?.id
                                    }
                                  >
                                    {getProductName?.name}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                          <div>
                            <Button
                              onClick={() => removeProductAccessories(index)}
                            >
                              Remove
                            </Button>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="col-span-2 mb-2">
                      <Button
                        className={Styles.addButton}
                        type="dashed"
                        onClick={addProductAccessories}
                        block
                        icon={<PlusOutlined />}
                      >
                        Add More Accessories
                      </Button>
                    </div>

                    <div className="col-span-2 mb-8">
                      <h4 className="font-semibold mb-1">Product Details</h4>
                      <JoditEditor
                        ref={editor}
                        value={convertedText}
                        config={jodiConfig as any}
                        // tabIndex={1} // tabIndex of textarea
                        onBlur={(newContent) => setConvertedText(newContent)} // preferred to use only this option to update the content for performance reasons
                        onChange={(newContent) => {}}
                      />
                    </div>
                    <div className="col-span-2 mb-4">
                      <h4 className="font-semibold mb-1">FAQ</h4>
                      <JoditEditor
                        ref={editor}
                        value={convertedTextForFAQ}
                        config={jodiConfig as any}
                        onBlur={(newContent) =>
                          setConvertedTextForFAQ(newContent)
                        }
                        onChange={(newContent) => {}}
                      />
                    </div>
                    <div className="col-span-2 mb-4">
                      <h4 className="font-semibold mb-1">Term & Conditions</h4>
                      <JoditEditor
                        ref={editor}
                        value={convertedTextForTermCondition}
                        config={jodiConfig as any}
                        onBlur={(newContent) =>
                          setConvertedTextForTermCondition(newContent)
                        }
                        onChange={(newContent) => {}}
                      />
                    </div>
                  </div>
                </TabPane>
                <TabPane tab="Service" key="5">
                  <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-4 mb-6  grid grid-cols-2 gap-x-4">
                    <h3 className="mb-4 text-xl font-bold col-span-2">
                      Service
                    </h3>

                    <div className="col-span-2">
                      <Form.Item
                        hasFeedback
                        label="Product Condition"
                        name="productCondition"
                      >
                        <Radio.Group
                          onChange={(e) => setProductCondition(e.target.value)}
                        >
                          <Radio value="NEW_PRODUCT">New Product</Radio>
                          <Radio value="USE_PRODUCT">Use Product</Radio>
                          <Radio value="OTHERS">Others</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </div>
                    <div>
                      <Form.Item
                        label="Product Handling Time"
                        style={{ marginBottom: 0 }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 12,
                          }}
                        >
                          <Form.Item
                            name="handlingTimeFrom"
                            style={{ flex: 1, marginBottom: 0 }}
                          >
                            <Input type="date" placeholder="From" />
                          </Form.Item>

                          <div
                            style={{
                              width: 28,
                              textAlign: "center",
                              lineHeight: "32px",
                              fontWeight: 600,
                              userSelect: "none",
                            }}
                          >
                            to
                          </div>

                          <Form.Item
                            name="handlingTimeTo"
                            style={{ flex: 1, marginBottom: 0 }}
                          >
                            <Input type="date" placeholder="To" />
                          </Form.Item>
                        </div>
                      </Form.Item>
                    </div>

                    <div className="">
                      <Form.Item
                        hasFeedback
                        label="Is Gift wrap Avelable?"
                        name="iswrapAvailable"
                        className="mr-5"
                      >
                        <Switch
                          checkedChildren={`true`}
                          unCheckedChildren={`false`}
                          defaultChecked={
                            (singleProductInfo as any)?.data?.iswrapAvailable
                          }
                        />
                      </Form.Item>
                    </div>
                  </div>
                </TabPane>
                <TabPane tab="Shipping" key="6">
                  <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-4 mb-6  grid grid-cols-2 gap-x-4">
                    <h3 className="mb-4 text-xl font-bold col-span-2">
                      Shipping
                    </h3>

                    {/* Product Weight Type + Product Weight (same width + nice gap) */}
                    <div className="grid grid-cols-2 gap-x-4">
                      <div className="">
                        <Form.Item
                          hasFeedback
                          label="Product Weight Type"
                          rules={[
                            {
                              required: false,
                              message: "Product Weight Type is required!",
                            },
                          ]}
                          name="productWeightUnit"
                          initialValue={productWeightUnit}
                        >
                          <Select
                            value={productWeightUnit}
                            className="w-full"
                            onChange={(val) => setProductWeightUnit(val)}
                            placeholder="Select Unit"
                          >
                            <Option value="kg">Kilogram</Option>
                            <Option value="g">Gram</Option>
                            <Option value="mg">Milligram</Option>
                            <Option value="µg">Microgram</Option>
                            <Option value="t">Tonne</Option>
                          </Select>
                        </Form.Item>
                      </div>

                      <div className="">
                        <Form.Item
                          hasFeedback
                          label="Product Weight"
                          rules={[
                            {
                              required: false,
                              message: "Product Weight is Required!",
                            },
                          ]}
                          name="productWeight"
                        >
                          <Input
                            id="productWeight"
                            type="number"
                            min={0}
                            className="w-full"
                            placeholder="Enter Product Weight"
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="">
                      <Form.Item
                        hasFeedback
                        label="Product Dimensions"
                        name="keyword"
                      >
                        <span>
                          <Space>
                            <Input
                              type="text"
                              name="dimensionLength"
                              placeholder="Length"
                              style={{ width: 100 }}
                            />
                            <Input
                              type="text"
                              name="dimensionWidth"
                              placeholder="Width"
                              style={{ width: 100 }}
                            />
                            <Input
                              type="text"
                              name="dimensionHeight"
                              placeholder="Height"
                              style={{ width: 100 }}
                            />

                            <Select
                              defaultValue="cm"
                              onChange={(val) => setDimensionUnit(val)}
                            >
                              <Option value="cm">CM</Option>
                              <Option value="m">M</Option>
                              <Option value="inc">Inc</Option>
                            </Select>
                          </Space>
                        </span>
                      </Form.Item>
                    </div>
                    <div className="">
                      <Form.Item
                        hasFeedback
                        label="Dangerous Goods"
                        name="dangerousGoods"
                        valuePropName="checked"
                      >
                        <Radio.Group>
                          <Checkbox
                            value="true"
                            onChange={(val) => setIsBattery(val.target.checked)}
                          >
                            Battery
                          </Checkbox>
                          <Checkbox
                            value="true"
                            onChange={(val) =>
                              setIsFlammable(val.target.checked)
                            }
                          >
                            Flammable
                          </Checkbox>
                          <Checkbox
                            value="true"
                            onChange={(val) => setIsLiquid(val.target.checked)}
                          >
                            Liquid
                          </Checkbox>
                          <Checkbox
                            value="true"
                            onChange={(val) => setIsNone(val.target.checked)}
                          >
                            None
                          </Checkbox>
                        </Radio.Group>
                      </Form.Item>
                    </div>
                    <div className="">
                      <Form.Item
                        hasFeedback
                        label="Safety Warning"
                        name="safetyWarning"
                      >
                        <Input
                          id="safetyWarning"
                          type="text"
                          placeholder="Enter Safety Warning"
                        />
                      </Form.Item>
                    </div>

                    <div>
                      <Form.Item
                        hasFeedback
                        label="Shipping Type"
                        name="shippingType"
                        valuePropName="checked"
                        initialValue={shippingTypes}
                      >
                        <Radio.Group>
                          <Checkbox
                            value="true"
                            onChange={(val) =>
                              setAllowFreeShipping(val.target.checked)
                            }
                          >
                            Free Shipping
                          </Checkbox>
                          <Checkbox
                            value="true"
                            onChange={(val) =>
                              setAllowPriorityDelivery(val.target.checked)
                            }
                          >
                            Priority Delivery
                          </Checkbox>
                          <Checkbox
                            value="true"
                            onChange={(val) =>
                              setAllowStandardDelivery(val.target.checked)
                            }
                          >
                            Standard Delivery
                          </Checkbox>
                          <Checkbox
                            value="true"
                            onChange={(val) =>
                              setAllowEconomyDelivery(val.target.checked)
                            }
                          >
                            Economy Delivery
                          </Checkbox>
                        </Radio.Group>
                      </Form.Item>
                    </div>
                    <div>
                      <Form.Item
                        hasFeedback
                        label="Shipping Zone"
                        name="shippingZone"
                        valuePropName="checked"
                      >
                        <Radio.Group>
                          <Checkbox value="Local_Shipping">
                            Local Shipping
                          </Checkbox>
                          <Checkbox value="Local_Pickup">Local Pickup</Checkbox>
                          <Checkbox value="International_Shipping">
                            International Shipping
                          </Checkbox>
                        </Radio.Group>
                      </Form.Item>
                    </div>
                  </div>
                </TabPane>
                <TabPane tab="Gondola" key="7">
                  <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-4 mb-6  grid grid-cols-2 gap-x-4">
                    <h3 className="mb-4 text-xl font-bold col-span-2">
                      Gondola Details
                    </h3>
                    <div className="">
                      <Form.Item
                        hasFeedback
                        label="Self Number"
                        name="selfNumber"
                      >
                        <Input
                          id="selfNumber"
                          type="text"
                          placeholder="Enter Self Number"
                        />
                      </Form.Item>
                    </div>
                    <div className="">
                      <Form.Item
                        hasFeedback
                        label="Row Number"
                        name="rowNumber"
                        rules={[
                          {
                            required: false,
                            message: "Row Number is Required!",
                          },
                        ]}
                      >
                        <Input
                          id="rowNumber"
                          type="text"
                          placeholder="Enter Row umber"
                        />
                      </Form.Item>
                    </div>
                  </div>
                </TabPane>
                <TabPane tab="SEO" key="8">
                  <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-4 mb-6  grid grid-cols-2 gap-x-4">
                    <h3 className="mb-4 text-xl font-bold col-span-2">SEO</h3>

                    <div className="col-span-2">
                      <Form.Item
                        hasFeedback
                        label="Meta Title"
                        name="metaTitle"
                        rules={[
                          {
                            required: true,
                            message: "Meta Title is Required!",
                          },
                        ]}
                      >
                        <Input
                          id="metaTitle"
                          type="text"
                          placeholder="Enter Meta Title"
                        />
                      </Form.Item>
                    </div>
                    <div className="col-span-2">
                      <Form.Item
                        hasFeedback
                        label="Keywords"
                        name="keyword"
                        rules={[
                          {
                            required: true,
                            message: "Keywords is Required!",
                          },
                        ]}
                      >
                        <Input.TextArea
                          id="keyword"
                          placeholder="Enter Product Keywords"
                          rows={3}
                        />
                      </Form.Item>
                    </div>

                    <div className="col-span-2">
                      <Form.Item
                        hasFeedback
                        label="Meta Description"
                        name="metaDescription"
                        rules={[
                          {
                            required: true,
                            message: "Meta Description is Required!",
                          },
                        ]}
                      >
                        <Input.TextArea
                          id="metaDescription"
                          placeholder="Enter Meta Description"
                          rows={3}
                        />
                      </Form.Item>
                    </div>
                    <div className="col-span-2">
                      <Form.Item
                        hasFeedback
                        label="Canonical Tag"
                        name="canonicalTag"
                      >
                        <Input
                          id="canonicalTag"
                          type="text"
                          placeholder="Enter Canonical Tag"
                        />
                      </Form.Item>
                    </div>
                    <div className="col-span-2">
                      <Form.Item
                        hasFeedback
                        label="Image Title"
                        name="imageTitle"
                      >
                        <Input
                          id="imageTitle"
                          type="text"
                          placeholder="Enter Image Title"
                        />
                      </Form.Item>
                    </div>
                    <div className="col-span-2">
                      <Form.Item
                        hasFeedback
                        label="Image Altr Text"
                        name="imageAltrText"
                      >
                        <Input
                          id="imageAltrText"
                          type="text"
                          placeholder="Enter Image Altr Text"
                        />
                      </Form.Item>
                    </div>
                    <div className="col-span-2">
                      <Form.Item
                        hasFeedback
                        label="Image Caption"
                        name="imageCaption"
                      >
                        <Input
                          id="imageCaption"
                          type="text"
                          placeholder="Enter Image Caption"
                        />
                      </Form.Item>
                    </div>
                    <div className="col-span-2">
                      <Form.Item
                        hasFeedback
                        label="Image Description"
                        name="imageDescription"
                      >
                        <Input.TextArea
                          id="imageDescription"
                          placeholder="Enter Image Description"
                          rows={2}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </TabPane>
              </Tabs>
              {/* end tabs */}
            </div>

            {/* ✅ ONLY buttons: Previous/Next (step 1-7), Previous + Submit + Reset (step 8) */}
            <div className="flex justify-end gap-3 mt-5">
              {TAB_KEYS.indexOf(activeKey) > 0 && (
                <Button
                  htmlType="button"
                  onClick={goPrev}
                  className="rounded-full px-6"
                >
                  Previous
                </Button>
              )}

              {activeKey === "8" ? (
                <>
                  <SubmitResetBtn
                    onClickSubmit={(e) => {
                      e.preventDefault();
                      setStartUpload("Uploading");
                      setStartUpload2("Uploading");
                    }}
                    onClickReset={resetData}
                    disabled={
                      loading ||
                      startUpload === "Uploading" ||
                      startUpload2 === "Uploading" ||
                      !!error
                    }
                    loading={
                      loading ||
                      startUpload === "Uploading" ||
                      startUpload2 === "Uploading" ||
                      !!error
                    }
                  />
                </>
              ) : (
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={goNext}
                  className="rounded-full px-6"
                >
                  Next
                </Button>
              )}
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};
export default AddRequestedProduct;
